<template>
  <div>
	<v-dialog :value="value" @input="$emit('input')" >
      <v-card> 
	      <v-toolbar class="lighten-2 noshadow ">
	          <v-toolbar-title>  <h5 class="modal-title" >{{header}}</h5> </v-toolbar-title>
	          <v-spacer></v-spacer>
	           <v-btn icon @click.native="close">
	            <v-icon>close</v-icon>
	          </v-btn>
	        </v-toolbar>
	        
       			 <v-card-title primary-title v-if="modalTitle =='verify'" class="modal-body-confirm distance">
	                <div class="form-group" >
	                   <div class="modal-body-confirm distance cleanbluemessage">
                         <span> {{title}}</span>
                      </div>
	                </div>
       		 	</v-card-title>
             <v-card-text class="distance">
            <v-form  v-if="modalTitle=='reject'">

              <!--  <label for="recipient-name" class="control-label"  v-html="title"></label> 
               <br/> -->
               <span id="error" class="error_form" v-show="isReject" style="display: block;color:red">Reject reason cannot be empty</span>
                       <br>
                  <v-container>
                   <v-textarea
                     outline
                      name="input-7-4"
                      ref="approve_remark" 
                      v-model="approve_remark" 
                      class="v_text"   

                    ></v-textarea>
                  </v-container>
      
            </v-form>
          </v-card-text>
         
		       <v-card-actions class="modal-footer">
	        		<v-spacer></v-spacer>
		            <v-btn  depressed @click="close" class="btn-secondary waves-effect waves-light ">Close</v-btn>
		            <v-btn  color="info"  @click.native="saveAction" class="btn-info waves-effect waves-light" v-if="modalTitle=='verify'">Confirm</v-btn>
		            <v-btn  color="info"  @click.native="saveAction" class="btn-info waves-effect waves-light" v-if="modalTitle=='reject'">Reject</v-btn>
		        </v-card-actions>
       		
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog2"
      max-width="290"
    >
      <v-card>
        <v-toolbar class="lighten-2 noshadow ">
          <v-toolbar-title>  <h5 class="modal-title" >Confirmation message</h5> </v-toolbar-title>
        </v-toolbar>
        <v-card-text  class="distance">
         Reject AIO completed
        </v-card-text>  
        <v-card-actions class="modal-footer">
              <v-spacer></v-spacer>
              
             <!--  <v-btn color="info" class="btn-info waves-effect waves-light" @click.native="saveReload">OK</v-btn> -->
              
            </v-card-actions>       
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog3"
      max-width="290"
    >
      <v-card>
        <v-toolbar class="lighten-2 noshadow ">
          <v-toolbar-title>  <h5 class="modal-title" >Error message</h5> </v-toolbar-title>
        </v-toolbar>
        <v-card-text  class="distance">
        {{errorReturn}}
        </v-card-text>  
        <v-card-actions class="modal-footer">
              <v-spacer></v-spacer>
              
              <v-btn color="info" class="btn-info waves-effect waves-light" @click.native="closeErr">OK</v-btn>
              
            </v-card-actions>       
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
   .form-group{
      margin-bottom: 0px !important;
  }
</style>
<script>
  import { loginService } from '@/components/_service/Users.js'
  export default {
   props:['value','camId','modalTitle','status'],
    data () {
      	return {
      		approve_remark:"",
      		id:this.camId,
          header:"",
          title:"",
          detail:{},
          isReject:false,
          dialog2:false,
          dialog3:false,
          flat_input_active: false,
          errorReturn:""
		    }
    },
  
    methods: {
      
 
    
       setFocus() {
        // Note, you need to add a ref="search" attribute to your input.
        //this.$refs.approve_remark.focus();
      },

      onFocus: function(event) {
            event.target.focus()
            this.isReject = false
            this.flat_input_active = true;
      },
       closeErr(){
           this.dialog3 = false;
        },
       close: function () {
       	//  this.id = ""
     		//  this.approve_remark = ""
         // debugger
          this.detail={}
          this.isReject = false
          console.log(this.isReject)
          this.$emit('input')

        },
        saveReload(){
        
          let path = "/detail/"+this.id+"/0"
          window.location.href = path
        },
        saveAction(){
            this.detail.id=this.id;
           // aio:aio
            if (this.modalTitle =="verify"){
                this.detail.aio = 1;
                               
                this.$store.dispatch('updateverifyaio', this.detail)
                  .then(() => {
                      this.close()

                      if(this.$store.state.updateverifyaio.aio_verified){
                        this.dialog3 = true;
                        this.errorReturn = this.$store.state.updateverifyaio.aio_verified[0];
                        //this.$router.replace({ name: 'detail', params: { id:  this.id,flightid:0 }});
                      }else{
                          this.saveReload();
                      }
                     
                     
                  })
                 .catch(err => {
                    console.log(err )
                   
                 })
                     
            //  console.log(JSON.stringify(this.detail))
            }else if (this.modalTitle =="reject"){
                 this.detail.action ="reject";
                 this.detail.remark = this.approve_remark

                if (!this.approve_remark) {
                     this.isReject = true
                     return false;
                }else if(this.approve_remark && this.detail.action=="reject"){
                    //console.log(this.detail);
                    
                    
                    this.$store.dispatch('updaterejectaio', this.detail)
                    .then(() => {
                       this.close()
                       this.dialog2 = true
                        this.saveReload();

                     
                    })
                   .catch(err => {
                      console.log(err )
                     
                   })    
                   //this.close();
                }
                    

            }
          
        }
    },
    beforeMount () {   
//console.log(this.status)

      if (this.modalTitle =="verify"){
            this.title ="Proceed to verify AIO?";
            this.header = "Confirmation message";
        }else 
        if (this.modalTitle =="reject"){
           this.title ="Remark"
           this.header = "Remark for Reject AIO";
          
      }
    }
  
  }

</script>